import {
  Box, Heading, Text,
} from '@chakra-ui/react';

const Error = ({ error = {} }) => (
  <Box id="error-page">
    <Heading mb="4">Oops!</Heading>
    <Text my="2">Sorry! an unexpected error has occurred.</Text>
    <Text>Our team has already been notified and the service will be restored as soon as possible.</Text>
    <Text my="4">
      <i>{error.statusText || error.message}</i>
    </Text>
  </Box>
);
export default Error;
